import React from 'react';
import { Violator } from '@hpstellar/core';
import { Reviews, Typography } from '@hpstellar/core/visId';

import ProductOverview from '../product-overview';
import AddToCart from '../add-to-cart';
import ImageGallery from './image-gallery';
import Price from './price-container';

import { resolveViolatorMessage } from '../../../product/get-product-props/util';
import { Helpers } from '../../../core';
import ProductQuickView from '../../../product/components/visId/product-tile/product-quick-view';
import { getQuickViewProps } from '../utils';

import './gift-guide-product-tile.less';

const GiftGuideProductCard = ({ key, product }) => {
    const { metadata, numReviews, rating, linkUrl } = product || {};
    const { violator } = metadata || {};
    const violatorMessage = violator || product.violatorMsg;
    return (
        <ProductQuickView {...getQuickViewProps(product)}>
            {({ onClick }) => {
                //overview override
                const handleKeyUp = e => {
                    e.preventDefault();
                    let charCode = e.keyCode || e.which;
                    if (charCode === 13) {
                        //when enter is pressed
                        onClick();
                    }
                };

                return (
                    <div tabIndex={0} className="gift-guide-product-tile" key={key}>
                        <ImageGallery product={product} onClick={onClick} />
                        <div className="product-details">
                            <Reviews
                                score={rating}
                                reviewsCount={numReviews}
                                GlobalLinkProps={{ to: `${Helpers.getRelativePath(linkUrl)}#reviews` }}
                                className="product-rating"
                            />
                            <Typography
                                variant="h4"
                                tag="h3"
                                aria-label={product.name}
                                tabIndex={0}
                                onKeyUp={handleKeyUp}
                                onClick={onClick}
                            >
                                {' '}
                                {product.name}
                            </Typography>
                            {violatorMessage && (
                                <Violator variation="offers" small className="purple-violator">
                                    {resolveViolatorMessage(violatorMessage)}
                                </Violator>
                            )}
                            <ProductOverview
                                className="visId"
                                overview={
                                    product.metadata.mktDiff ||
                                    product.attributes.prdOverview ||
                                    (product.ksps || []).join(' • ')
                                }
                                richTextProps={{ visId: true }}
                            />
                            <div className="tile-footer">
                                <Price className="prd-price" product={product} />
                                <AddToCart openModal={onClick} product={product} text={'Buy now'} className="visId" />
                            </div>
                        </div>
                    </div>
                );
            }}
        </ProductQuickView>
    );
};

export default GiftGuideProductCard;
